import Builder from './builder'

var factory = {
  createListBox (options) {
    return new Builder().makeListPopover().addHandleScroll().get(options)
  },
  createSelectableBoxOffClickDeadline (options) {
    return new Builder().makeSelect()
      .addDefaultEvent()
      .addDismiss()
      .addHandleScroll()
      .addDismissOnOffClick()
      .addDimissTimerForHover(null, true)
      .get({ ...options, multiSelect: true })
  },
  createDefaultListBox (options) {
    return new Builder().makeListPopover().addDefaultEvent().get(options)
  },
  createExtendedListBox (options) {
    return new Builder().makeListPopover().addDismiss().addDismissOnOffClick().get(options)
  },
  createListBoxWithHoverOver (options) {
    return new Builder().makeListPopover().addHoverOver(options.hoverOver, false).addDismiss().get(options)
  },
  createOperator (options) {
    return new Builder().makeOperator().addDismissOnClickTimer(options.miliseconds).addDismiss().get(options)
  },
  createNotification (options) {
    return new Builder().makeNotifiation().addDefaultEvent().get(options)
  },
  createCustomPopover (options) {
    return new Builder().makeCustom(options.popover).addDefaultEvent().get(options)
  }
}

export default factory



// WEBPACK FOOTER //
// ./src/app/components/common/popover/factory.js